// extracted by mini-css-extract-plugin
export default {"font-renta":"AdminConsole_font-renta__+ftmJ","adminConsole":"AdminConsole_adminConsole__VGNLZ","info":"AdminConsole_info__1R+8r","active":"AdminConsole_active__lOKto"};